import { isAcme } from 'isAcme';

import { qCards as qCardsAcme } from './defs/Acme/qCardIndex';
import { qCards as qCardsQuicken } from './defs/Quicken/qCardIndex';

export const qCards = isAcme ? qCardsAcme : qCardsQuicken;
